/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
   
==========================================================================================*/


import Vue from 'vue'
import VueProxy from 'vuex-proxy'

import app from './app'
import auth from './auth'
import user from './user'
import product from './product'
import order from './order'

Vue.use(VueProxy)

export default VueProxy.Store({
  ...app,
  modules: {
    auth,
    user,
    product,
    order,
  },
})
